import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de posologie médicale précise";
const DESCRIPTION =
  "Calculatrice de posologie médicale précise en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de posologie médicale précise, calculatrice de posologie médicale précise, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/medicine-dosage-calculator/";

function MedicineDosageCalculator() {
  const [totalDosage, setTotalDosage] = useState("");
  const [singleDosage, setSingleDosage] = useState("");
  const [weight, setWeight] = useState("");
  const [frequency, setFrequency] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      if (weight && totalDosage) {
        let totalDose = parseInt(weight) * parseInt(totalDosage);
        let singleDose = totalDose;

        if (frequency === "deux fois par jour") {
          singleDose = totalDose / 2;
        } else if (frequency === "trois fois par jour") {
          singleDose = totalDose / 3;
        } else if (frequency === "quatre fois par jour") {
          singleDose = totalDose / 4;
        } else if (frequency === "toutes les 4 heures") {
          singleDose = totalDose / 6;
        }

        setResult({
          totalDose,
          singleDose: frequency !== "une fois par jour" ? singleDose : null,
        });
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleFrequencyChange = (selectedFrequency) => {
    setFrequency(selectedFrequency);
    setSingleDosage(selectedFrequency !== "une fois par jour");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Calculatrice intelligente et précise de posologie spécialement conçue pour simplifier le processus de calcul des posologies. Grâce à son interface intuitive, vous pouvez facilement entrer le poids du patient et la dose prescrite pour obtenir un tableau de posologie quotidienne détaillé. La calculatrice est basée sur les dernières normes médicales pour assurer l'exactitude des résultats, ce qui vous donne la tranquillité d'esprit et la confiance dans les décisions que vous prenez. Que vous soyez médecin, pharmacien ou parent, cette calculatrice est l'outil parfait pour vous aider à gérer les posologies médicamenteuses efficacement.
                </p>
                <p>Pour calculer la dose quotidienne, vous pouvez suivre les étapes suivantes:</p>
                <ul>
                  <li>Entrez le poids du patient</li>
                  <li>Entrez la dose unique en milligrammes</li>
                  <li>Choisissez le nombre de fois que la dose est prise par jour</li>
                </ul>
                <p>
                  La calculatrice a été développée sur la base de{" "}
                  <a
                    href="https://lo.unisa.edu.au/pluginfile.php/1902200/mod_resource/content/6/Maths%20for%20Midwifery%20and%20Nursing%20Dosage%20Calculation%20-%20Worksheet_2022.pdf"
                    rel="nofollow"
                  >
                    calcul de dose pour l'Université du Sud de l'Australie - feuille de travail
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="weight">
                      <label className="form-label ms-2">Entrez le poids (kg)</label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Entrez le poids"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="dosage">
                      <label className="form-label ms-2">
                        Entrez la posologie (mg)
                      </label>
                      <input
                        id="dosage"
                        type="number"
                        value={totalDosage}
                        onChange={(e) => setTotalDosage(e.target.value)}
                        placeholder="Entrez la posologie"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="frequency">
                        Choisissez la posologie quotidienne
                      </label>
                      <select
                        id="frequency"
                        value={frequency}
                        onChange={(e) => handleFrequencyChange(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Choisissez la posologie quotidienne</option>
                        <option value="une fois par jour">Une fois par jour</option>
                        <option value="deux fois par jour">Deux fois par jour</option>
                        <option value="trois fois par jour">Trois fois par jour</option>
                        <option value="quatre fois par jour">Quatre fois par jour</option>
                        <option value="toutes les 4 heures">Toutes les 4 heures</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p className="text-white">Dose totale: {result.totalDose} mg</p>
                      {result.singleDose && (
                        <p className="text-white">Dose unique: {result.singleDose.toFixed(2)} mg</p>
                      )}
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Dosage des mdicaments</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Usage professionnel</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedicineDosageCalculator;
